<span class="font-bold">
  @if (remainingTime() > 9) {
    00:{{ remainingTime() }}
  } @else {
    00:0{{ remainingTime() }}
  }
</span>
